import { render, staticRenderFns } from "./SmsSend.vue?vue&type=template&id=3c16462b&scoped=true"
import script from "./SmsSend.vue?vue&type=script&lang=js"
export * from "./SmsSend.vue?vue&type=script&lang=js"
import style0 from "./SmsSend.vue?vue&type=style&index=0&id=3c16462b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c16462b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c16462b')) {
      api.createRecord('3c16462b', component.options)
    } else {
      api.reload('3c16462b', component.options)
    }
    module.hot.accept("./SmsSend.vue?vue&type=template&id=3c16462b&scoped=true", function () {
      api.rerender('3c16462b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Sms/SmsSend.vue"
export default component.exports